import { createStyles, makeStyles, Typography } from '@material-ui/core'
import dayjs from 'dayjs'
import clsx from 'clsx'
import Link from '../Link/Link'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getStoresByOrderId } from '../../redux/actions/inStore'
import { postProductToReturn } from '../../redux/actions/order'
import { getUser, getUserOrders } from '../../redux/actions/user'
import { Cart } from '../../typings/base'
import { DEBUG } from '../../utils/constants'
import { downloadURI, isPurchasedItem } from '../../utils/utils'
import Button from '../Button/Button'
import Price from '../Shop/Price'
import OrderProductRow from './OrderProductRow'
import CMSText from '../Global/CMSText'
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)
import { ORDER_ITEM_TYPE } from '../../utils/constants'
import OrderSecondHandProductRow from './OrderSecondHandProductRow'
import { getSecondHandProductInformation } from '../../utils/cart'
import { useTakeback } from '../../hooks/useTakeback'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2, 1, 4),
      [theme.breakpoints.down('md')]: {
        padding: 0,
        marginBottom: theme.spacing(6),
      },
    },
    alignCenter: {
      textAlign: 'center',
    },
    lastOrderContainer: {
      display: 'inline-flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    button: {
      [theme.breakpoints.down('md')]: {
        fontSize: 12,
        padding: theme.spacing(0.5, 1),
      },
    },
    orderTotals: {
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(1),
    },
    orderTotalsRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(1, 0.5),
      borderTop: `1px solid ${theme.extraColors.greyLight}`,
    },
    promotionAmount: {
      color: theme.palette.success.main,
    },
    confirmationRecapOrder: {
      margin: theme.spacing(2, 0),
    },
  })
)

type Tprops = {
  user: any
  doc: any
  settings: any
  cart: Cart
  t: any
  getUser: () => any
  returnProducts: any
  parameters: any
  getUserOrders: () => any
  postProductToReturn: (products: any) => any
  getStoresByOrderId: any
  showPrice?: boolean
  showSizes?: boolean
  lastOrder: any
  takeBack: any
}

const mapStateToProps = (state) => ({
  user: state.user,
  returnProducts: state.returnProducts,
  cart: state.cart,
  parameters: state.parameters,
})

const mapDispatchToProps = {
  getUser: getUser,
  getUserOrders: getUserOrders,
  getStoresByOrderId: getStoresByOrderId,
  postProductToReturn: postProductToReturn,
}

const RecapOrder = ({
  user,
  parameters,
  cart,
  t,
  getStoresByOrderId,
  doc,
  settings,
  returnProducts,
  postProductToReturn,
  showPrice,
  showSizes,
  lastOrder,
  takeBack,
  getUser,
}: Tprops) => {
  const classes = useStyles()
  const router = useRouter()
  const { productCheckState } = useTakeback()
  const states = productCheckState(takeBack)
  const [warehouses, setWarehouses] = useState([])
  const secondHandLastOrder = lastOrder?.items?.filter(
    (item) => item.type === ORDER_ITEM_TYPE.SECOND_HAND
  )
  const rentalOrPurchaseLastOrder = lastOrder?.items?.filter(
    (item) =>
      item.type === ORDER_ITEM_TYPE.RENTAL ||
      item.type === ORDER_ITEM_TYPE.PURCHASE
  )

  useEffect(() => {
    if (!user?.user?.id) {
      const getUserOrRedirect = async () => {
        const isUser = await getUser()
        if (isUser.type === 'GET_USER_FAILURE') {
          //No redirect if in debug mode
          if (router.asPath !== DEBUG) {
            //user has no valid jwt token, ie he's disconnected
            //router.push('/')
          }
        }
      }
      getUserOrRedirect()
    }
  }, [user?.user?.id, router])

  useEffect(() => {
    const Async = async () => {
      if (parameters?.items?.in_store && returnProducts?.items) {
        const orderNumbers = []
        returnProducts?.items?.map((product) => {
          orderNumbers.push(product.orderNumber)
        })
        const response: any = await getStoresByOrderId(orderNumbers)
        if (response?.type === 'GET_STORES_BY_ORDER_NUMBER_SUCCESS') {
          setWarehouses(response?.stores)
          const warehouseOrdersProducts = []
          response?.stores.map((warehouse, indexWarehouse) => {
            warehouseOrdersProducts.push({
              name: warehouse.name,
              address: warehouse.address,
              city: warehouse.city,
              orders: [],
            })
            warehouse?.orders?.map((whOrder) => {
              if (
                typeof returnProducts.items.find(
                  (returnedProduct) =>
                    returnedProduct.orderNumber === whOrder.orderNumber
                ) !== 'undefined'
              ) {
                const order = returnProducts.items.find(
                  (returnedProduct) =>
                    returnedProduct.orderNumber === whOrder.orderNumber
                )
                warehouseOrdersProducts[indexWarehouse].orders.push({
                  number: order.orderNumber,
                  tokenValue: order.orderToken,
                  products: [
                    {
                      product: order.product,
                      puid: whOrder?.products?.find(
                        (product) => product.sku === order.Sku
                      )?.id,
                      totalWithoutPromotion: order.total,
                    },
                  ],
                })
              }
            })
          })
          setWarehouses(warehouseOrdersProducts)
        }
      }
    }
    Async()
  }, [returnProducts])

  const downloadPdf = async () => {
    const data = []
    returnProducts?.items?.map((product) => {
      data?.push({
        lizeeSKU: product?.Sku,
        quantity: product?.quantity,
      })
    })
    const products = { products: data, gender: user?.user?.gender }

    const response = await postProductToReturn(products)
    if (response.type === 'POST_PRODUCT_TO_RETURN_SUCCESS') {
      if (response?.response[0]?.pdfUrl) {
        downloadURI(
          response.response[0].pdfUrl,
          `${process.env.STORE}_${response.response[0].trackingCode}`
        )
      }
    }
  }

  return (
    <div className={classes.root}>
      <div className={clsx(classes.alignCenter, 'recapOrder__title')}>
        <Typography variant={'h3'} color={'secondary'}>
          <CMSText
            asText
            data={doc?.data?.title}
            defaultText={t('texts:confirmation:title')}
          />
        </Typography>
      </div>
      {returnProducts?.items?.length > 0 && !parameters?.items?.in_store && (
        <>
          <div className={classes.lastOrderContainer}>
            <Typography variant={'h5'} className="recapOrder__date">
              <CMSText
                asText
                data={doc?.data?.articles_return}
                defaultText={t('texts:confirmation:articles_return')}
              />
              &nbsp;
              {dayjs(cart?.item?.endLeasingDate, 'DD/MM/YYYY')
                .subtract(2, 'day')
                .format('L')}
            </Typography>
            <Button
              variant={'contained'}
              color={'secondary'}
              size={'small'}
              onClick={() => downloadPdf()}
              className={classes.button}
            >
              <CMSText
                asText
                data={doc?.data?.generate_vouchers}
                defaultText={t('texts:confirmation:generate_vouchers')}
              />
            </Button>
          </div>
          {returnProducts?.items?.map((item, index) => {
            return (
              <div key={index}>
                <OrderProductRow
                  t={t}
                  settings={settings}
                  item={item}
                  index={index}
                  showSizes={showSizes}
                />
              </div>
            )
          })}
        </>
      )}
      {parameters?.items?.in_store && (
        <>
          {warehouses.map((warehouse) => {
            return (
              <>
                <div className={classes.lastOrderContainer}>
                  <Typography variant={'h4'}>
                    {t('texts:confirmation:to_return')}{' '}
                    {warehouse.name + ' ' + warehouse.address}
                  </Typography>
                  <Button
                    variant={'contained'}
                    color={'secondary'}
                    size={'small'}
                    onClick={() => downloadPdf()}
                    className={classes.button}
                  >
                    <CMSText
                      asText
                      data={doc?.data?.generate_vouchers}
                      defaultText={t('texts:confirmation:generate_vouchers')}
                    />
                  </Button>
                </div>
                {warehouse.orders.map((order) => {
                  return (
                    <>
                      {order.products.map((item, index) => {
                        return (
                          <div key={index}>
                            <OrderProductRow
                              t={t}
                              settings={settings}
                              showSizes={showSizes}
                              item={item}
                              showQuantity={true}
                              orderNumber={order.number}
                              index={index}
                              showPrice={showPrice}
                            />
                          </div>
                        )
                      })}
                    </>
                  )
                })}
              </>
            )
          })}
        </>
      )}
      {user?.orders?.length > 0 && (
        <>
          <div className={classes.lastOrderContainer}>
            <Typography variant={'h5'} className="recapOrder__date">
              <CMSText
                asText
                data={doc?.data?.articles_to_send}
                defaultText={t('texts:confirmation:articles_to_send')}
              />
              &nbsp;
              {dayjs(lastOrder?.startLeasingDate, 'DD/MM/YYYY').format(
                'DD/MM/YYYY'
              )}
            </Typography>
            <Link href={'account'}>
              <a>
                <Button
                  variant={'outlined'}
                  color={'secondary'}
                  size={'small'}
                  className={clsx(classes.button, 'recapOrder__account_cta')}
                >
                  <CMSText
                    asText
                    data={doc?.data?.account_cta}
                    defaultText={t('texts:confirmation:account_cta')}
                  />
                </Button>
              </a>
            </Link>
          </div>
          <Typography variant={'h4'}>
            {t('texts:confirmation:order_number')}{' '}
            {lastOrder?.items?.length > 0 && lastOrder?.number}
          </Typography>
          {/* recap order on confirmation page */}
          {/* rental and purchase product list */}
          {rentalOrPurchaseLastOrder?.map((item, index) => {
            return (
              <div key={index} className={classes.confirmationRecapOrder}>
                <OrderProductRow
                  t={t}
                  settings={settings}
                  showSizes={showSizes}
                  item={item}
                  index={index}
                  showQuantity={true}
                  isBought={isPurchasedItem(item)}
                  isConfirmation
                  showPrice={showPrice}
                  currency={lastOrder?.currency}
                />
              </div>
            )
          })}
          {secondHandLastOrder?.map((item) => {
            const currentProduct = getSecondHandProductInformation(item)

            // Group units by quality if quantity selector is enabled
            if (settings?.second_hand_has_quantity_selector) {
              // Group by productState (quality)
              const groupedByQuality = currentProduct?.units?.reduce(
                (acc, unit) => {
                  const quality = unit?.productState
                  if (!acc[quality]) {
                    acc[quality] = {
                      units: [],
                      totalPrice: 0,
                    }
                  }
                  acc[quality].units.push(unit)
                  acc[quality].totalPrice += unit?.productPrice || 0
                  return acc
                },
                {} as Record<string, { units: any[]; totalPrice: number }>
              )

              return Object.entries(groupedByQuality || {}).map(
                ([quality, groupData]) => {
                  const group = groupData as {
                    units: any[]
                    totalPrice: number
                  }
                  return (
                    <div
                      key={`${item.id}-${quality}`}
                      className={classes.confirmationRecapOrder}
                    >
                      <OrderSecondHandProductRow
                        settings={settings}
                        productName={currentProduct?.productName}
                        productImage={currentProduct?.productImage}
                        productPrice={group.totalPrice}
                        productState={states[`${quality}`]?.title}
                        quantity={group.units.length}
                        taxonPromotionPercent={
                          currentProduct?.taxonPromotionPercent
                        }
                      />
                    </div>
                  )
                }
              )
            }

            // Default behavior: display each unit individually
            return currentProduct?.units?.map((unit, index) => {
              return (
                <div key={index} className={classes.confirmationRecapOrder}>
                  <OrderSecondHandProductRow
                    settings={settings}
                    productName={currentProduct?.productName}
                    productImage={currentProduct?.productImage}
                    productPrice={unit?.productPrice}
                    productState={states[`${unit?.productState}`]?.title}
                    taxonPromotionPercent={
                      currentProduct?.taxonPromotionPercent
                    }
                  />
                </div>
              )
            })
          })}
          {showPrice && lastOrder?.totals && (
            <div className={classes.orderTotals}>
              {lastOrder.totals.promotion !== 0 && (
                <div className={classes.orderTotalsRow}>
                  <Typography variant="body2">
                    {t('texts:basket:reduction')}
                  </Typography>
                  <Typography
                    variant="body2"
                    className={clsx(classes.promotionAmount)}
                  >
                    <b>
                      <Price
                        amount={lastOrder.totals.promotion}
                        showDayOrMonth={false}
                        currency={lastOrder.currency}
                      />
                    </b>
                  </Typography>
                </div>
              )}
              <div className={classes.orderTotalsRow}>
                <Typography variant="body2">
                  <b>{t('texts:basket:total_with_subscription')}</b>
                </Typography>
                <Typography variant="body2">
                  <b>
                    <Price
                      amount={lastOrder.totals.total}
                      showDayOrMonth={false}
                      currency={lastOrder.currency}
                    />
                  </b>
                </Typography>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(RecapOrder)
